import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from '../layouts/Layout';
import AppLayout from '../layouts/AppLayout';
import { app_path, paths } from '../app/paths';
import SuspenseLoader from "../layouts/SuspenseLoader";
import RequireAuth from "../services/authentication/RequireAuth";

const ConfirmAccount = lazy(() => import('../pages/ConfirmAccount'));
const UserHomepage = lazy(() => import('../pages/UserHomepage'));
const LogIn = lazy(() => import('../pages/login/LogIn'));
const SignUp = lazy(() => import('../pages/login/SignUp'));
const ForgotPassword = lazy(() => import('../pages/login/ForgotPassword'));
const ProfilePage = lazy(() => import('../pages/sidebar/ProfilePage'));
const OrganisationPage = lazy(() => import('../pages/sidebar/OrganisationPage'));
const CustomizationPage = lazy(() => import('../pages/sidebar/CustomizationPage'));
const PomodoroPage = lazy(() => import('../pages/sidebar/PomodoroPage'));
const WorkedHoursPage = lazy(() => import('../pages/sidebar/WorkedHoursPage'));
const ReportPage = lazy(() => import('../pages/sidebar/ReportPage'));
const ProjectsDashboardPage = lazy(() => import('../pages/sidebar/ProjectsDashboardPage'));
const MembersPage = lazy(() => import('../pages/sidebar/MembersPage'));
const ArchivesPage = lazy(() => import('../pages/ArchivesPage'));
const SettingsPage = lazy(() => import('../pages/SettingsPage'));

export default function RootRouter() {
    return (
        <Routes>
            <Route path={paths.index} element={<Layout />}>
                {/* public routes */}
                <Route path={paths.confirm_account} element={<Suspense fallback={<SuspenseLoader/>}><ConfirmAccount/></Suspense>}/>
                <Route path={paths.auth.login} element={<Suspense fallback={<SuspenseLoader/>}><LogIn/></Suspense>}/>
                <Route path={paths.auth.register} element={<Suspense fallback={<SuspenseLoader/>}><SignUp/></Suspense>}/>
                <Route path={paths.auth.forgotPassword} element={<Suspense fallback={<SuspenseLoader/>}><ForgotPassword/></Suspense>}/>

                {/* protected routes */}
                <Route path={app_path + "/*"} element={
                    <RequireAuth>
                        <Routes>
                            <Route path={"/"} element={<Suspense fallback={<SuspenseLoader/>}><AppLayout/></Suspense>}>
                                <Route path={`/`} index element={<Suspense fallback={<SuspenseLoader/>}><UserHomepage/></Suspense>}/>
                                <Route path={paths.profile} element={<Suspense fallback={<SuspenseLoader/>}><ProfilePage/></Suspense>}/>
                                <Route path={paths.organisation} element={<Suspense fallback={<SuspenseLoader/>}><OrganisationPage/></Suspense>}/>
                                <Route path={paths.customization} element={<Suspense fallback={<SuspenseLoader/>}><CustomizationPage/></Suspense>}/>
                                <Route path={paths.pomodoro} element={<Suspense fallback={<SuspenseLoader/>}><PomodoroPage/></Suspense>}/>
                                <Route path={paths.worked_hours} element={<Suspense fallback={<SuspenseLoader/>}><WorkedHoursPage/></Suspense>}/>
                                <Route path={paths.report} element={<Suspense fallback={<SuspenseLoader/>}><ReportPage/></Suspense>}/>
                                <Route path={paths.projects_dashboard} element={<Suspense fallback={<SuspenseLoader/>}><UserHomepage/></Suspense>}/>
                                <Route path={paths.archives} element={<Suspense fallback={<SuspenseLoader/>}><ArchivesPage/></Suspense>}/>
                                <Route path={paths.settings + "/*"} element={<Suspense fallback={<SuspenseLoader/>}><SettingsPage/></Suspense>}>
                                    <Route path="profile" element={<Suspense fallback={<SuspenseLoader/>}><ProfilePage/></Suspense>}/>
                                    <Route path="projects-dashboard" element={<Suspense fallback={<SuspenseLoader/>}><ProjectsDashboardPage/></Suspense>}/>
                                    <Route path="organisation" element={<Suspense fallback={<SuspenseLoader/>}><OrganisationPage/></Suspense>}/>
                                    <Route path="customization" element={<Suspense fallback={<SuspenseLoader/>}><CustomizationPage/></Suspense>}/>
                                    <Route path="pomodoro" element={<Suspense fallback={<SuspenseLoader/>}><PomodoroPage/></Suspense>}/>
                                    <Route path="worked-hours" element={<Suspense fallback={<SuspenseLoader/>}><WorkedHoursPage/></Suspense>}/>
                                    <Route path="report" element={<Suspense fallback={<SuspenseLoader/>}><ReportPage/></Suspense>}/>
                                    <Route path="members" element={<Suspense fallback={<SuspenseLoader/>}><MembersPage/></Suspense>}/>
                                </Route>
                            </Route>
                        </Routes>
                    </RequireAuth>
                }/>
            </Route>
        </Routes>
    );
}
